import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_WAREHOUSE_OPERATION_TYPE_',
  }
);

export interface DeleteWarehouseOperationTypeState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteWarehouseOperationTypeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteWarehouseOperationTypeState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (
  state: DeleteWarehouseOperationTypeState,
  action: DeleteWarehouseOperationTypeRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteWarehouseOperationTypeState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (state: DeleteWarehouseOperationTypeState, action: FailureAction) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteWarehouseOperationTypeState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteWarehouseOperationType = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteWarehouseOperationTypeTypes = Types;
export const DeleteWarehouseOperationTypeActions = Creators;
